// import components
import {
  styled,
  Fab,
  Dialog,
  keyframes,
  IconButton,
  alpha,
  Box
} from '@mui/material';
import { Icon } from '@sdb/planning-ui';

export const pulse = keyframes`
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.1); opacity: 0.9; }
  100% { transform: scale(1); opacity: 1; }
`;

export const waveHand = keyframes`
  0% { transform: rotate(0deg); }
  10% { transform: rotate(14deg); }
  20% { transform: rotate(-8deg); }
  30% { transform: rotate(14deg); }
  40% { transform: rotate(-4deg); }
  50% { transform: rotate(10deg); }
  60% { transform: rotate(0deg); }
  100% { transform: rotate(0deg); }
`;

export const bounceOutToTheRight = keyframes`
  0% { right: 24px; }
  30% { right: 30px; }
  100% { right: -100px; }
`;

export const StyledNewFeatureFab = styled(Fab, {
  shouldForwardProp: (prop) => prop !== 'bounceOut'
})<{ bounceOut?: boolean }>(({ theme, bounceOut }) => ({
  position: 'fixed',
  display: 'flex',
  bottom: theme.spacing(6),
  color: theme.palette.common.white,
  animation: bounceOut
    ? `${bounceOutToTheRight} 0.6s ease-in-out`
    : `${pulse} 2s infinite`,
  right: bounceOut ? '-100px' : '24px'
}));

export const StyledNewFeatureDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: '100%',
    maxWidth: '600px'
  },

  '& .MuiDialogContent-root': {
    paddingBottom: 0
  },

  '& .MuiDialogContent-root a': {
    color: theme.palette.primary.main,

    '&:hover': {
      textDecoration: 'underline'
    }
  }
}));

export const StyledNewFeatureFontAwesomeSvgIcon = styled(Icon)(() => ({
  animation: `${waveHand} 2s infinite`,
  transformOrigin: 'bottom center',
  display: 'inline-block'
}));

export const StyledImageBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'backgroundUrl'
})<{
  backgroundUrl: string;
}>(({ backgroundUrl, theme }) => () => ({
  width: '100%',
  height: '300px',
  display: 'block',
  borderTopLeftRadius: theme.shape.borderRadius,
  borderTopRightRadius: theme.shape.borderRadius,
  background: `center / cover no-repeat url("${backgroundUrl}")`
}));

export const StyledNewFeatureIconButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  zIndex: 2,
  top: theme.spacing(2),
  right: theme.spacing(2),
  backgroundColor: alpha(theme.palette.common.white, 0.7),
  '&:hover': {
    backgroundColor: theme.palette.common.white
  }
}));
